<template>
    <el-dialog
        title="回访"
        :visible="show"
        width="50%"
        :close-on-click-modal="false"
        :before-close="handleClose"
        class="dialog_container"
    >
        <div class="cancellationBox">
            <el-form label-width="180px" ref="orderInfo" :model="orderInfo">
                <el-form-item label="客户名称：">
                    <el-col :span="10">
                        <el-input
                            disabled
                            v-model="orderInfo.customerName"
                        ></el-input>
                    </el-col>
                </el-form-item>
                <el-form-item label="联系方式：">
                    <el-row :gutter="10">
                        <el-col :span="10">
                            <el-input
                                disabled
                                v-model="orderInfo.customerphone"
                            ></el-input>
                        </el-col>
                        <el-col :span="1">
                            <i
                                class="el-icon-phone"
                                style="cursor: pointer"
                                title="电话"
                                @click="callPhone"
                            ></i>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item label="地址:">
                    <div style="display: flex; margin-bottom: 5px">
                        <el-input
                            disabled
                            placeholder="请输入"
                            v-model="orderInfo.provinceName"
                        ></el-input>
                        <el-input
                            disabled
                            placeholder="请输入"
                            v-model="orderInfo.city"
                        ></el-input>
                        <el-input
                            disabled
                            placeholder="请输入"
                            v-model="orderInfo.areaName"
                        ></el-input>
                        <el-input
                            disabled
                            placeholder="请输入"
                            v-model="orderInfo.streetName"
                        ></el-input>
                        <!-- @change="handleCommunityChange" -->
                        <el-input
                            disabled
                            placeholder="请输入"
                            v-model="orderInfo.communityName"
                        ></el-input>
                    </div>
                    <el-input
                        v-model="orderInfo.address"
                        style="padding: 0px; border: 0"
                        disabled
                        class="el-input__inner"
                        placeholder="请输入关键字"
                        autocomplete="off"
                    ></el-input>
                </el-form-item>
                <el-form-item label="工单开始图片：">
                    <el-row :gutter="10">
                        <el-col :span="10">
                            <img
                                :src="orderInfo.picStart"
                                style="width: 178px; height: 178px"
                            />
                        </el-col>
                    </el-row>
                </el-form-item>
            </el-form>
            <el-form
                label-width="180px"
                ref="serviceInfo"
                :model="serviceInfo"
                :rules="rules"
            >
                <el-form-item label="服务人员是否准时：" prop="isOnTime">
                    <el-radio-group
                        v-model="serviceInfo.isOnTime"
                        :disabled="
                            orderInfo.returnVisitId != null &&
                            orderInfo.repeats == false
                        "
                        @change="timeTap"
                    >
                        <el-radio label="0">是</el-radio>
                        <el-radio label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="服务态度是否良好：" prop="isGood">
                    <el-radio-group
                        v-model="serviceInfo.isGood"
                        :disabled="
                            orderInfo.returnVisitId != null &&
                            orderInfo.repeats == false
                        "
                        @change="timeTap"
                    >
                        <el-radio label="0">是</el-radio>
                        <el-radio label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="服务人员着装是否整洁：" prop="isTidy">
                    <el-radio-group
                        v-model="serviceInfo.isTidy"
                        :disabled="
                            orderInfo.returnVisitId != null &&
                            orderInfo.repeats == false
                        "
                        @change="timeTap"
                    >
                        <el-radio label="0">是</el-radio>
                        <el-radio label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="服务工作是否符合规范：" prop="isStandard">
                    <el-radio-group
                        v-model="serviceInfo.isStandard"
                        :disabled="
                            orderInfo.returnVisitId != null &&
                            orderInfo.repeats == false
                        "
                        @change="timeTap"
                    >
                        <el-radio label="0">是</el-radio>
                        <el-radio label="1">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="拨打状态：" prop="dialingStatus">
                    <el-radio-group
                        v-model="serviceInfo.dialingStatus"
                        :disabled="
                            orderInfo.returnVisitId != null &&
                            orderInfo.repeats == false
                        "
                    >
                        <el-radio label="0">正常接听</el-radio>
                        <el-radio label="1">无人接听</el-radio>
                        <el-radio label="2">关机</el-radio>
                        <el-radio label="3">停机</el-radio>
                        <el-radio label="4">空号</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="服务对象评价：" prop="ojectEvaluation">
                    <el-input
                        type="textarea"
                        v-model="serviceInfo.ojectEvaluation"
                        :disabled="
                            orderInfo.returnVisitId != null &&
                            orderInfo.repeats == false
                        "
                    ></el-input>
                </el-form-item>
                <el-form-item label="回访结果：" prop="results">
                    <el-radio-group
                        v-model="serviceInfo.results"
                        :disabled="
                            orderInfo.returnVisitId != null &&
                            orderInfo.repeats == false
                        "
                    >
                        <el-radio label="0">合格</el-radio>
                        <el-radio label="1">不合格</el-radio>
                        <el-radio label="2">作废</el-radio>
                        <el-radio label="3">虚假工单</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="理由：" prop="reason">
                    <el-input
                        type="textarea"
                        v-model="serviceInfo.reason"
                        :disabled="
                            orderInfo.returnVisitId != null &&
                            orderInfo.repeats == false
                        "
                    ></el-input>
                </el-form-item>
            </el-form>
            <div
                style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 15px;
                "
            >
                <el-button
                    type="primary"
                    @click="cancelSend('serviceInfo')"
                    v-if="orderInfo.returnVisitId == null"
                    >确 定</el-button
                >
                <el-button @click="handleClose('serviceInfo')">取 消</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import request from "@/utils/request"
import exportVue from "@/utils/exportVue"

export default {
    name: "returnVisit",
    props: {
        showVisit: {
            type: Boolean,
            default: false,
        },
        orderInfo: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            serviceInfo: {
                isOnTime: "0",
                isGood: "0",
                isTidy: "0",
                isStandard: "0",
                ojectEvaluation: "",
                results: "0",
                reason: "",
                chooseRadio: [],
                dialingStatus: "",
            },
            isHui: 0,
            rules: {
                isOnTime: [
                    {
                        required: true,
                        message: "请选择服务人员是否准时",
                        trigger: "change",
                    },
                ],
                results: [
                    {
                        required: true,
                        message: "请选择回访结果",
                        trigger: "change",
                    },
                ],
                //  reason:[ {
                //     required: true,
                //     message: "请输入原因",
                //     trigger: "change",
                // },],
                isGood: [
                    {
                        required: true,
                        message: "请选择服务态度是否良好",
                        trigger: "change",
                    },
                ],
                isTidy: [
                    {
                        required: true,
                        message: "请选择服务人员着装是否整洁",
                        trigger: "change",
                    },
                ],
                isStandard: [
                    {
                        required: true,
                        message: "请选择服务工作是否符合规范",
                        trigger: "change",
                    },
                ],
                ojectEvaluation: [
                    {
                        required: true,
                        message: "请输入服务对象评价",
                        trigger: "blur",
                    },
                ],
                dialingStatus: [
                    {
                        required: true,
                        message: "请选择拨打状态",
                        trigger: "blur",
                    },
                ],
            },
        }
    },
    watch: {
        showVisit(newVal) {
            if (newVal) {
                // this.serviceInfo.id = this.orderInfo.id
            }
        },
    },
    computed: {
        show() {
            return this.showVisit
        },
    },
    created() {
        this.orderInfo.returnVisitId = this.orderInfo.returnVisitId
        this.orderInfo.timeStart = this.orderInfo.timeStart
        request({
            url: "/jjyl/servicePgdReturnVisit/info/getByServicePgdId",
            method: "POST",
            data: {
                servicePgdId: this.orderInfo.id,
            },
        }).then((res) => {
            if (res.content) {
                this.chooseRadio = [1, 1, 1, 1]
                this.serviceInfo.isOnTime = res.content.isOnTime
                this.serviceInfo.isGood = res.content.isGood
                this.serviceInfo.isTidy = res.content.isTidy
                this.serviceInfo.isStandard = res.content.isStandard
                this.serviceInfo.ojectEvaluation = res.content.ojectEvaluation
                this.serviceInfo.results = res.content.results
                this.serviceInfo.reason = res.content.reason
                this.serviceInfo.orderNum = res.content.orderNum
                this.serviceInfo.dialingStatus = res.content.dialingStatus
                if (this.serviceInfo.isOnTime == 1) {
                    this.chooseRadio.splice(0, 1)
                }
                if (this.serviceInfo.isGood == 1) {
                    this.chooseRadio.splice(0, 1)
                }
                if (this.serviceInfo.isTidy == 1) {
                    this.chooseRadio.splice(0, 1)
                }
                if (this.serviceInfo.isStandard == 1) {
                    this.chooseRadio.splice(0, 1)
                }
                this.$forceUpdate()
            } else {
                this.serviceInfo = {
                    isOnTime: "0",
                    isGood: "0",
                    isTidy: "0",
                    isStandard: "0",
                    results: "0",
                    reason: "",
                    ojectEvaluation: "",
                }
                this.chooseRadio = [1, 1, 1, 1]
            }
        })
    },
    mounted() {},
    methods: {
        // 切换评价 results
        timeTap(val) {
            if (val == 0) {
                this.chooseRadio.push(1)
            } else {
                this.chooseRadio.splice(0, 1)
            }
            if (this.chooseRadio.length < 2) {
                this.serviceInfo.results = "1"
            } else {
                this.serviceInfo.results = "0"
            }
        },

        // 关闭弹框
        handleClose() {
            this.$emit("update:showVisit", false)
            this.serviceInfo = {
                isOnTime: "0",
                isGood: "0",
                isTidy: "0",
                isStandard: "0",
                results: "0",
                reason: "",
                ojectEvaluation: "",
            }
            this.chooseRadio = [1, 1, 1, 1]
            // this.showVisit = false
        },
        callPhone() {
            this.$store.dispatch("setPhone", this.orderInfo.customerphone)
            exportVue.$emit("question", true)
            this.handleClose()
        },
        // 作废 虚拟工单
        getCancle(url, parmar) {
            const self = this
            parmar.id = self.orderInfo.id
            request({
                url: url,
                method: "POST",
                data: parmar,
            }).then((res) => {
                if (res.code === 200) {
                    this.$emit("updateList")
                    this.$message.success(res.message)
                    this.handleClose()
                    this.isHui = 1
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        //不合格
        getNoPass(url, parmar) {
            const self = this
            request({
                url: url,
                method: "POST",
                data: { id: self.orderInfo.id },
            }).then((res) => {
                if (res.code === 200) {
                    this.$emit("updateList")
                    this.$message.success(res.message)
                    this.handleClose()
                    this.isHui = 1
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 确定.
        cancelSend(formName) {
            const self = this
            let url = ""
            let parmar = {
                servicePgdId: this.orderInfo.id,
                ...this.serviceInfo,
            }
            parmar.closeReason = self.serviceInfo.reason
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: "Loading",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)",
                    })
                    if (self.serviceInfo.results == 0) {
                        url = "/jjyl/servicePgdReturnVisit/info/save"
                    } else if (self.serviceInfo.results == 1) {
                        if (self.serviceInfo.reason == "") {
                            self.$message.error("请输入不合格理由")
                            return
                        }
                        url = "/jjyl/servicePgd/info/visitAbnormal"
                        // parmar.id =
                    } else {
                        if (self.serviceInfo.reason == "") {
                            self.$message.error("请输入理由")
                            return
                        }
                        url = "/jjyl/servicePgd/info/Invalid"
                        // 修改状态为待作废
                        parmar.states =
                            self.serviceInfo.results == 2 ? "4" : "8"
                        parmar.orderNum = self.orderInfo.orderNum

                        // 添加作废理由
                        parmar.closeReason = self.serviceInfo.reason
                        // 添加作废申请人
                        parmar.askCloseName = self.$store.state.info.name
                    }
                    request({
                        url: "/jjyl/servicePgdReturnVisit/info/save",
                        method: "POST",
                        data: parmar,
                    })
                        .then((res) => {
                            if (res.code === 200) {
                                if (
                                    self.serviceInfo.results == 2 ||
                                    self.serviceInfo.results == 3
                                ) {
                                    self.getCancle(url, parmar)
                                } else if (self.serviceInfo.results == 1) {
                                    self.getNoPass(url, parmar)
                                } else {
                                    this.$emit("updateList")
                                    this.$message.success(res.message)
                                    this.handleClose()
                                    this.isHui = 1
                                }
                                loading.close()
                            } else {
                                loading.close()
                                this.$message.error(res.message)
                            }
                        })
                        .catch((error) => {
                            this.$emit("update:showVisit", false)
                            loading.close()
                        })
                } else {
                    return false
                }
            })
        },
    },
}
</script>

<style scoped>
</style>